import { render, staticRenderFns } from "./index.vue?vue&type=template&id=592a1adc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=592a1adc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a1adc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slide: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/Slide/index.vue').default,VideoCard: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/VideoCard/index.vue').default,VideoSwiper: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/VideoSwiper/index.vue').default})
